import React from "react";
import ModalInfo from "../../ModalInfo";

class Page2 extends React.Component {
  state = {
    visible: true,

    modalShow: true,
    modalTitle: "INSTRUCTIONS",
    modalContent: (
      <div>
        <p>
          As a postgraduate student, you will need to act quickly at the start
          of your course to meet the recruitment deadlines for graduate schemes.
          Graduate schemes start dates coincide with undergraduate completion
          dates. However, some employers may have later start dates. Some PhD’s
          are also advertised at the start of the academic year, therefore the
          earlier you start thinking about your future career the better
          prepared you will be.
          <br />
          <br />
          On this page we have put together an application timeline for PhD’s,
          Graduate Schemes and Graduate Jobs. Click on each tab for more
          information.
        </p>
      </div>
    ),
  };
  checkPageVisibility(pageNum) {
    if (pageNum == 2) {
      this.setState({
        visible: true,
      });
    } else {
      this.setState({
        visible: false,
      });
    }
  }
  render() {
    let modalClose = () => this.setState({ modalShow: false });

    return (
      <div>
        {this.state.visible ? (
          <div>
            <nav className="navbar fixed-top navbar-expand-sm bg-light page-title">
              <ul className="navbar-nav">
                <li className="nav-item">
                  <h3 className="py-0  d-md-block">
                    UK job and PhD application timeline
                  </h3>
                </li>
                <li className="nav-item"></li>
              </ul>
              <ul className="nav navbar-nav ml-auto">
                <div>
                  <i
                    className="fas fa-info-square fa-3x"
                    onClick={() =>
                      this.setState({
                        modalShow: true,
                        modalTitle: "INSTRUCTIONS",
                        modalContent: (
                          <div>
                            <p>
                              As a postgraduate student, you will need to act
                              quickly at the start of your course to meet the
                              recruitment deadlines for graduate schemes.
                              Graduate schemes start dates coincide with
                              undergraduate completion dates. However, some
                              employers may have later start dates. Some PhD’s
                              are also advertised at the start of the academic
                              year, therefore the earlier you start thinking
                              about your future career the better prepared you
                              will be.
                              <br />
                              <br />
                              On this page we have put together an application
                              timeline for PhD’s, Graduate Schemes and Graduate
                              Jobs. Click on each tab for more information.
                            </p>
                          </div>
                        ),
                      })
                    }
                  ></i>
                </div>
              </ul>
            </nav>
            <div className="container-fluid vertical-center">
              <div className="card-columns value-cards">
                <div
                  className="card border-light text-dark border-dark value-card"
                  onClick={() =>
                    this.setState({
                      modalShow: true,
                      modalTitle:
                        "Graduate Schemes usually open for applications from",
                      modalContent: (
                        <div>
                          <p>
                            Graduate Schemes typically recruit 12 months in
                            advance. Graduate schemes are offered by a wide
                            range of employers and usually last for up-to
                            2-years. It’s the defined time frame and structure
                            that normally distinguishes a graduate scheme or
                            programme from the wider class of 'graduate job'.
                            Applications open as early as September particularly
                            in certain sectors. Some employers do recruit all
                            year round.
                          </p>
                        </div>
                      ),
                    })
                  }
                >
                  <div className="card-header text-center text-uppercase font-weight-bold">
                    AUG - JAN
                  </div>
                  <div className="card-body">
                    <center>
                      <span id="moduleContentText_2">Graduate Schemes</span>
                    </center>
                  </div>
                </div>
                <div
                  className="card border-light text-dark border-dark value-card"
                  onClick={() =>
                    this.setState({
                      modalShow: true,
                      modalTitle:
                        "PhD applications usually open from September",
                      modalContent: (
                        <div>
                          <p>
                            A significant number of PhD’s are advertised at this
                            time. A PhD is an advanced postgraduate degree
                            involving three or more years of independent
                            research on an original topic. They can last between
                            3-4 years. Applications open as early as October
                            although some programmes recruit all year round.
                          </p>
                        </div>
                      ),
                    })
                  }
                >
                  <div className="card-header text-center text-uppercase font-weight-bold">
                    OCT - APR
                  </div>
                  <div className="card-body">
                    <center>
                      <span id="moduleContentText_2">PhD</span>
                    </center>
                  </div>
                </div>
                <div
                  className="card border-light text-dark border-dark value-card"
                  onClick={() =>
                    this.setState({
                      modalShow: true,
                      modalTitle: "Graduate Jobs recruit all year round",
                      modalContent: (
                        <div>
                          <p>
                            Graduate Jobs are advertised all year round. These
                            jobs are driven by business need and start dates are
                            usually soon after the selection process has been
                            completed so there's less waiting time to start the
                            job. Recruit all year round depending on business
                            needs.
                          </p>
                        </div>
                      ),
                    })
                  }
                >
                  <div className="card-header text-center text-uppercase font-weight-bold">
                    JAN - DEC
                  </div>
                  <div className="card-body">
                    <center>
                      <span id="moduleContentText_2">Graduate Jobs</span>
                    </center>
                  </div>
                </div>
              </div>
            </div>
            <ModalInfo
              show={this.state.modalShow}
              onHide={modalClose}
              title={this.state.modalTitle}
              content={this.state.modalContent}
            />
          </div>
        ) : (
          <div></div>
        )}
      </div>
    );
  }
}

export default Page2;
